import PrevadzkovaKnihaSections from "./PrevadzkovaKnihaSections"
import {splitEmailList} from "../util";

export default class PrevadzkovaKnihaEditCtrl {

  static resolve = {
    kniha: (PrevadzkovaKnihaService, $stateParams) => PrevadzkovaKnihaService.getRecord($stateParams.id),
    zakaznikProvider: (ZakaznikService) => (search) => ZakaznikService.search(search).then(l => l.map(z => ({id: z.id, nazov: z.name}))),
    zosProvider: (ServisService) => (zid, search) => ServisService.list({zakaznik: zid, search: search}).then(l => l.map(z => ({id: z.id, nazov: z.nazov}))),
    userList: (UzivatelService) => UzivatelService.list(),
    pobockaProvider: (ProjektService) => (search) => ProjektService.searchPobocka(search).then(l => l.map(p => ({id: p.id, nazov: p.name, zakaznik: {nazov: (p.links.find(l => l.targetClass == "Zakaznik")||{}).name}}))),
    getZakaznik: (ZakaznikService) => (id) => ZakaznikService.get(id)
  }

  constructor(kniha, zakaznikProvider, $state, userList, pobockaProvider, getZakaznik, zosProvider){
    this.item = kniha;
    this.zakaznikProvider = zakaznikProvider;
    this.userList = userList;
    this.pobockaProvider = pobockaProvider;
    this.getZakaznik = getZakaznik;
    this.zosProvider = zosProvider;
    this.typyKnihy = ["EPS", "HSP", "FIREFLY", "DR", "SAH", "CCTV", "EZS", "SKVaD", "VCIP"];
    if(this.item.isNew()) this.prefill();

    this.item.onUpdate(() => window.history.back())
    this.item.onCreate((i) => $state.go("prevadzkova-kniha", {id: i.data.id}))
    this.item.onCancel(() => window.history.back())
    this.item.onDelete(() => $state.go("prevadzkova-kniha-list"))
    this.item.form.field("acl").setModified();
    this.item.form.field("ustredne").setModified();
    this.item.form.field("hlasice").setModified();
    this.item.form.field("signalizacnePrvky").setModified();
    this.item.form.field("ineZariadenia").setModified();
    this.item.form.field("osobyZodpovedne").setModified();
    this.item.form.field("osobyKontrolne").setModified();
    this.item.form.field("osobyObsluha").setModified();
    this.sections = PrevadzkovaKnihaSections;
  }

  prefill(){
    var defaults = {
      hlasice: [
        {"druh":"Automatický hlásič", "typ":"MTD 533", "pocet": 0},
        {"druh":"Automatický hlásič", "typ":"OSD", "pocet": 0},
        {"druh":"Automatický hlásič", "typ":"DMD", "pocet": 0},
        {"druh":"Tlačidlový hlásič", "typ":"MCP 535", "pocet": 0},
        {"druh":"Tlačidlový hlásič", "typ":"MCP 545", "pocet": 0},
        {"druh":"Lineárny hlásič", "typ":"Fireray 5000", "pocet": 0},
      ],
      signalizacnePrvky: [
        {"druh":"Maják", "typ":"(OUT)", "pocet": 0},
        {"druh":"Siréna", "typ":"(OUT)", "pocet": 0},
      ],
      ineZariadenia: [
        {"druh":"Nasávací systém", "typ":"ASD 535", "pocet": 0},
        {"druh":"Vstupno/výstupný modul ", "typ":"OI3", "pocet": 0},
        {"druh":"Vstupno/výstupný modul ", "typ":"O2I4", "pocet": 0},
        {"druh":"Výstupný modul ", "typ":"REL4", "pocet": 0},
        {"druh":"Vstupný modul ", "typ":"IM4", "pocet": 0},
        {"druh":"Externý panel", "typ":" ", "pocet": 0},
        {"druh":"Pomocný zdroj ", "typ":"24V/5A", "pocet": 0},
        {"druh":"Akumulátor", "typ":"38Ah/12V", "pocet": 0},
        {"druh":"Akumulátor", "typ":"18Ah/12V", "pocet": 0},
        {"druh":"Akumulátor", "typ":"7Ah/12V", "pocet": 0},
        {"druh":"Telefónny komunikátor", "typ":"(OUT)", "pocet": 0},
        {"druh":"Rozhlas", "typ":"(OUT)", "pocet": 0},
        {"druh":"Vstupné dvere", "typ":"(OUT)", "pocet": 0},
        {"druh":"Únikové dvere", "typ":"(OUT)", "pocet": 0},
        {"druh":"Požiarne deliace dvere", "typ":"(OUT)", "pocet": 0},
        {"druh":"Požiarne klapky,SU", "typ":"(IN)", "pocet": 0},
        {"druh":"ZODT", "typ":"(OUT)", "pocet": 0},
        {"druh":"Vypínanie NN", "typ":"(OUT)", "pocet": 0},
        {"druh":"Signál  pre MaR  -VZT", "typ":"(OUT)", "pocet": 0},
        {"druh":"Signál z SHZ", "typ":"(IN)", "pocet": 0},
        {"druh":"Signál  pre Aisys", "typ":"(OUT)", "pocet": 0},
        {"druh":"Prenos správ – stála služba", "typ":"(OUT)", "pocet": 0},
      ]
    }

    console.log(this.item);
    for(var key of Object.keys(defaults)){
      this.item.form[key].value = this.item.form[key].value.concat(defaults[key]);
    }


  }

  confirmDelete(){
    if(window.confirm("Naozaj odstrániť prevádzkovú knihu?")){
      this.item.del();
    }
  }

  can(acl, typ){
    return new AclProxy(acl, typ);
  }

  addAcl(user){
    this.item.form.acl.value.push({uzivatel: user, typyZaznamu: []});
  }

  removeAcl(acl){
    this.item.form.acl.value = this.item.form.acl.value.filter(a => a!=acl);
  }

  copyPrevadzkovatel(){
    this.getZakaznik(this.item.form.zakaznik.value.id).then(z => {
      this.item.form.field("prevadzkovatelNazov").value = z.nazov;
      this.item.form.field("prevadzkovatelAdresa").value = z.adresa;
      this.item.form.field("prevadzkovatelEmail").value = splitEmailList(z.fakturacnyEmail)[0];
      this.item.form.field("prevadzkovatelTelefon").value = "";
      this.item.form.field("prevadzkovatelMobil").value = "";
    })
  }


}


class AclProxy {

  constructor(acl, typ){
    this.acl = acl;
    this.typ = typ;  
  }

  get value(){
    return this.acl.typyZaznamu.indexOf(this.typ) >= 0;
  }

  set value(yes){
    this.acl.typyZaznamu = this.acl.typyZaznamu.filter(i => i!=this.typ);
    if(yes) this.acl.typyZaznamu.push(this.typ);
  }

}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaEditCtrl.js